const searchInTopBar = document.querySelector('#search_blogs');
const form = document.querySelector('#search_form');
const input = document.querySelector('.topbar__search__input');
const closeBtn = document.querySelector('#search_close');
const hitBtn = document.querySelector('#search_hit');


if (!!searchInTopBar !== false) { 
  
  searchInTopBar.addEventListener( 'click', (e) => {
    if (!searchInTopBar.classList.contains('topbar__search__isopen')) {
      searchInTopBar.classList.add('topbar__search__isopen');
      toggleCloseBtn('show');
      toggleForm('show');
      toggleHitBtn('show');
      input.focus();
    } else {
      console.log({searchtopbar: e.target.id});
      if ( e.target.id === 'search_close') {
        toggleCloseBtn( 'close' );
        toggleForm('close');
        toggleHitBtn('close');
        searchInTopBar.classList.remove('topbar__search__isopen');
      }
    }
  });

  hitBtn.addEventListener( 'click',  (e) => {
    if (searchInTopBar.classList.contains('topbar__search__isopen')) {
      form.submit();
    } else {
      toggleCloseBtn('show');
      toggleForm('show');
      toggleHitBtn('show');
    }
  });

}

function toggleCloseBtn(arg) {
  if ( arg === 'show') {
    closeBtn.style.width = "40px";
    closeBtn.style.height = "40px";
    closeBtn.style.left = "-160px";
    closeBtn.style.padding = "15px";
  } else if (arg === 'close') {
    closeBtn.style.width = "0";
    closeBtn.style.height = "40px";
    closeBtn.style.left = "-50px";
    closeBtn.style.padding = "15px";
  }
}

function toggleForm(arg) {
  if ( arg === 'show') {
    form.style.width = "200px"
    form.style.left = "-120px"
  } else if (arg === 'close') {
    form.style.width = "0px"
    form.style.left = "-100px"
  }
}

function toggleHitBtn(arg) {
  if ( arg === 'show') {
    hitBtn.style.left = "95px";
  } else if (arg === 'close') {
    hitBtn.style.left = "-25px";
  }
}